import {CONFIG} from '../globals/config';

const breakPoint = 770;

export const isDesktop = (): boolean => {
	return ! CONFIG.isMobile && window.innerWidth > breakPoint;
};

export const isMobile = (): boolean => {
	return CONFIG.isMobile || window.innerWidth < breakPoint;
};
